import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import router from "routes";
import { get } from "util/requests";
import colors from "colors";
import moment from "moment";
import { ae_columns } from "../../edc/components/crf/log_form_table";
import { ThemeProvider } from "@mui/material";
import { theme } from "config";

let columns = [...ae_columns];
columns.unshift({
  field: "subject_id",
  headerName: "Subject ID",
  width: 160,
  align: "center",
  headerAlign: "center",
});

export default function AETable(props) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    get("/ae").then((ret) => setEvents(ret.data));
  }, []);

  return (
    <DataGrid
      rows={events}
      columns={columns}
      disableColumnSelector
      disableRowSelectionOnClick
      disableColumnMenu
      pageSize={10}
      rowsPerPageOptions={[10]}
      hideFooterSelectedRowCount
      pageSizeOptions={[10]}
      columnHeaderHeight={34}
      rowHeight={34}
      autoPageSize
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      sx={{
        boxShadow: 0,
        border: 1,
        borderColor: "#f0f0f0",
        "& .MuiDataGrid-cell:hover": {
          color: "#8349fd",
          cursor: "pointer",
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-columnHeader ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-topContainer .MuiDataGrid-filler ": {
          // backgroundColor: "#f7f3fe",
          backgroundColor: colors.table_header_background,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
          color: "#333",
        },
      }}
      onRowClick={(data, event) => {
        let link = data.row.path;
        if (event.metaKey || event.ctrlKey) {
          let new_win = window.open(link, "_blank");
          if (new_win && !new_win.closed) {
            new_win.focus();
          }
        } else {
          router.navigate(link);
        }
      }}
    />
  );
}
